<template>
  <v-container id="landing" fluid fill-height>
    <v-layout class="flex-column" align-center justify-center>
      <v-flex sm8 lg4>
        <v-row>
          <v-col align="center" cols="12">
            <v-form @submit.prevent="submit" ref="form" v-model="valid">
              <v-alert type="info" color="green" icon="mdi-information-outline">
                Please make sure to have your proof of identification/passport
                and latest payslip ready for the application form.
              </v-alert>
              <v-text-field
                v-model="pastelCode"
                :rules="pastelCodeRules"
                label="Company Code"
              ></v-text-field>
              <v-select
                v-model="salaryFrequency"
                :items="items"
                :rules="salaryFrequencyRules"
                label="Salary Frequency"
              ></v-select>
              <v-alert
                v-if="validPastelCode === false"
                type="warning"
                icon="mdi-alert-outline"
              >
                Incorrect Company Code entered. Please consult your HR
                department for the correct code to use.
              </v-alert>
              <v-alert
                v-if="validSalaryFrequency === false"
                type="warning"
                icon="mdi-alert-outline"
              >
                No Loan Contracts available for selected Salary Frequency for
                this Company Code. Please consult your HR department.
              </v-alert>
              <v-btn
                class="mr-4"
                :dark="valid && !loading"
                color="primary"
                type="submit"
                :disabled="!valid || loading"
                :loading="loading"
              >
                submit
              </v-btn>
              <v-btn @click="clear"> clear </v-btn>
              <v-alert outlined color="grey darken-2" class="mt-5 caption">
                Your Information will only be processed for the purpose for
                which it was collected and in terms of the Protection of
                Personal Information Act. For further information kindly see our
                Privacy Policy on our website
                <a target="blank" href="https://www.bradburyfin.co.za"
                  >www.bradburyfin.co.za</a
                >.
              </v-alert>
            </v-form>
          </v-col>
        </v-row>
      </v-flex>
      <div class="iframecontainer">
        <iframe
          style="position: absolute"
          width="100%"
          height="100%"
          src="https://www.youtube-nocookie.com/embed/E6Xtb2FNLcQ?rel=0"
          title="Bradbury Assist App"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { layout } from '@/mixins';
import { API } from 'aws-amplify';
import router from '@/router';
import { showErrorSnackbar } from '@/mixins/errorHandler';

export default {
  name: 'EmployeeLanding',
  mixins: [layout],

  components: {},

  data: () => ({
    theme: 'website',
    loading: false,
    valid: false,
    validPastelCode: true,
    validSalaryFrequency: true,
    pastelCode: '',
    salaryFrequency: null,
    company: null,
    items: ['Weekly', 'Monthly', 'Fortnightly'],
    pastelCodeRules: [(v) => !!v || 'Company Code is required'],
    salaryFrequencyRules: [(v) => !!v || 'Salary Frequency is required'],
  }),

  methods: {
    submit() {
      this.validSalaryFrequency = true;
      this.validPastelCode = true;
      this.loading = true;
      this.queryCompany();
    },
    clear() {
      this.pastelCode = '';
      this.loading = false;
      this.valid = false;
      this.salaryFrequency = null;
      this.$refs.form.reset();
    },
    async queryCompany() {
      try {
        const processedPastelCode = this.pastelCode.trim().toUpperCase();

        const companyByPastelCode = /* GraphQL */ `
          query CompanyByPastelCode(
            $pastelCode: String!
            $sortDirection: ModelSortDirection
            $filter: ModelCompanyFilterInput
            $limit: Int
            $nextToken: String
          ) {
            companyByPastelCode(
              pastelCode: $pastelCode
              sortDirection: $sortDirection
              filter: $filter
              limit: $limit
              nextToken: $nextToken
            ) {
              items {
                id
                pastelCode
                LoanTypes {
                  items {
                    loanType {
                      period
                    }
                  }
                }
              }
            }
          }
        `;

        const response = await API.graphql({
          query: companyByPastelCode,
          variables: { pastelCode: processedPastelCode },
        });

        console.log('Query response:', response); // Debug log

        const company = response.data.companyByPastelCode.items[0];

        if (company) {
          this.company = company;
          this.validPastelCode = true;
          await this.queryLoanTypes();
        } else {
          this.validPastelCode = false;
          this.loading = false;
        }
      } catch (err) {
        console.error('Error in queryCompany:', err);
        showErrorSnackbar();
        this.loading = false;
      }
    },

    async queryLoanTypes() {
      try {
        const queryCompanyLoanTypes =
          this.company.LoanTypes?.items?.map((clt) => clt.loanType.period) ||
          [];

        if (this.salaryFrequency === 'Monthly') {
          const loanTypePeriod = ['Months'];
          const validateLoanTypes = queryCompanyLoanTypes.filter((lt) =>
            loanTypePeriod.includes(lt)
          );
          if (validateLoanTypes.length > 0) {
            this.validSalaryFrequency = true;
            router.push({
              name: 'Apply',
              params: {
                companyId: this.company.id,
                salaryFrequency: this.salaryFrequency,
              },
            });
          } else {
            this.validSalaryFrequency = false;
          }
        } else if (this.salaryFrequency === 'Weekly') {
          const loanTypePeriod = ['Wks/Mths', 'Weeks'];
          const validateLoanTypes = queryCompanyLoanTypes.filter((lt) =>
            loanTypePeriod.includes(lt)
          );
          if (validateLoanTypes.length > 0) {
            this.validSalaryFrequency = true;
            router.push({
              name: 'Apply',
              params: {
                companyId: this.company.id,
                salaryFrequency: this.salaryFrequency,
              },
            });
          } else {
            this.validSalaryFrequency = false;
          }
        } else if (this.salaryFrequency === 'Fortnightly') {
          const loanTypePeriod = ['Fortnights'];
          const validateLoanTypes = queryCompanyLoanTypes.filter((lt) =>
            loanTypePeriod.includes(lt)
          );
          if (validateLoanTypes.length > 0) {
            this.validSalaryFrequency = true;
            router.push({
              name: 'Apply',
              params: {
                companyId: this.company.id,
                salaryFrequency: this.salaryFrequency,
              },
            });
          } else {
            this.validSalaryFrequency = false;
          }
        }
        this.loading = false;
      } catch (err) {
        console.error('Error in queryLoanTypes:', err);
        showErrorSnackbar();
        this.loading = false;
      }
    },
  },

  computed: {},
};
</script>

<style scoped>
.iframecontainer {
  position: relative;
  height: 0;
}
@media screen and (max-width: 599px) {
  .iframecontainer {
    padding-bottom: calc((720 / 1280) * 100%);
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .iframecontainer {
    padding-bottom: calc((720 / 1280) * 66.6666666667%);
    width: 66.6666666667%;
  }
}
@media screen and (min-width: 1264px) {
  .iframecontainer {
    padding-bottom: calc((720 / 1280) * 33.3333333333%);
    width: 33.3333333333%;
  }
}
</style>
